<h2 mat-dialog-title *ngIf="data.mode === viewModalEnum.Create">Nueva dirección</h2>
<h2 mat-dialog-title *ngIf="data.mode === viewModalEnum.Edit">Editar dirección</h2>
<h2 mat-dialog-title *ngIf="data.mode === viewModalEnum.View">Detalle de dirección</h2>

<mat-dialog-content>
  <form [formGroup]="form">
    <div class="row">
      <div class="col-12">
        <div class="form-group mb-3">
          <label>Buscar dirección</label>
          <div class="input-group">
            <input #addressInput type="text" class="form-control" placeholder="Busca una dirección o selecciona en el mapa" />
            <button *ngIf="!isView" type="button" class="btn btn-primary" (click)="searchAddress()">
              <i class="fa-solid fa-magnifying-glass"></i>
            </button>
          </div>
          <small class="form-text text-muted">Puedes buscar una dirección o seleccionarla en el mapa</small>
        </div>
      </div>

      <div class="col-12 mb-5">
        <div class="map-container">
          <div #mapContainer class="h-100 w-100 border rounded"></div>
          <small class="form-text text-muted mt-2">
            <span *ngIf="!isView">Puedes hacer clic en el mapa para seleccionar una ubicación o arrastrar el marcador.</span>
            <span *ngIf="isView">Ubicación seleccionada</span>
          </small>
        </div>
      </div>
      
      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
        <div class="form-group mb-3">
          <label>País <span class="text-danger">*</span></label>
          <div>
            <select formControlName="countryId" class="form-control" (change)="onChangeCountry()">
              <option value="">Seleccione</option>
              <option *ngFor="let c of countryList" [value]="c.id">{{c.text}}</option>
            </select>
          </div>
          <app-form-errors [controlName]="form.controls['countryId']"></app-form-errors>
        </div>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
        <div class="form-group mb-3">
          <label>Estado / provincia <span class="text-danger">*</span></label>
          <div>
            <select formControlName="stateId" class="form-control" (change)="onChangeState()">
              <option value="">Seleccione</option>
              <option *ngFor="let st of stateList" [value]="st.id">{{st.text}}</option>
            </select>
          </div>
          <app-form-errors [controlName]="form.controls['stateId']"></app-form-errors>
        </div>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
        <div class="form-group mb-3">
          <label>Ciudad <span class="text-danger">*</span></label>
          <div>
            <select formControlName="cityId" class="form-control" (change)="onChangeCities()">
              <option value="">Seleccione</option>
              <option *ngFor="let ct of cityList" [value]="ct.id">{{ct.text}}</option>
            </select>
          </div>
        </div>
        <app-form-errors [controlName]="form.controls['cityId']"></app-form-errors>
      </div>

      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
        <div class="form-group mb-3">
          <label>Sector/Barrio</label>
          <div>
            <select formControlName="districtId" class="form-control">
              <option value="">Seleccione</option>
              <option *ngFor="let ct of districtList" [value]="ct.id">{{ct.text}}</option>
            </select>
          </div>
        </div>
        <app-form-errors [controlName]="form.controls['districtId']"></app-form-errors>
      </div>
      
      <div class="col-12">
        <div class="form-group mb-3">
          <label>Dirección <span class="text-primary">(Ingrese aquí la dirección que desea guardar)</span></label>
          <div>
            <input formControlName="address" type="text" class="form-control" placeholder="Ingrese la dirección que desea guardar" />
          </div>
          <app-form-errors [controlName]="form.controls['address']"></app-form-errors>
          <small class="form-text text-muted">Si lo desea, puede proporcionar una dirección personalizada diferente a la sugerida</small>
        </div>
        
      </div>
      
      <div class="col-12">
        <div class="form-group mb-3">
          <label>Dirección sugerida por el mapa</label>
          <div>
            <input formControlName="mapAddress" type="text" class="form-control bg-light" readonly />
          </div>
        </div>
      </div>

      <!-- Hidden fields for latitude and longitude -->
      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 d-none">
        <div class="form-group mb-3">
          <label>Latitud</label>
          <div>
            <input formControlName="latitude" type="text" class="form-control" readonly />
          </div>
        </div>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 d-none">
        <div class="form-group mb-3">
          <label>Longitud</label>
          <div>
            <input formControlName="longitude" type="text" class="form-control" readonly />
          </div>
        </div>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
        <div class="form-check mt-2">
          <input class="form-check-input" type="checkbox" formControlName="isPrimary" id="chkPrincipal">
          <label class="form-check-label" for="chkPrincipal">
            ¿Dirección principal?
          </label>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end" >
  <button mat-button class="btn btn-danger me-3" (click)="closeDialog()">Cerrar</button>
  <button mat-raised-button class="btn btn-success " (click)="save()" *ngIf="!isView">Guardar</button>
</mat-dialog-actions>